"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textfield = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const input_styles_1 = require("@/components/common/input/input.styles");
const textfield_helpers_1 = require("@/components/common/input/semantics/textfield.helpers");
require("@/components/common/input/input");
let Textfield = class Textfield extends (0, textfield_helpers_1.withTextfieldState)(lit_1.LitElement) {
    constructor() {
        super(...arguments);
        this.type = 'text';
    }
    render() {
        return (0, lit_1.html) `
      ${(0, textfield_helpers_1.renderFieldLabel)(this.inputId, this.label, this.optional)}
      <slot name="link"></slot>
      <div class="textfield-control" aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}>
        <slot name="leading"></slot>
        <mm-input
          input-id=${this.inputId}
          .type=${this.type}
          .value=${this.value}
          .name=${this.name}
          .placeholder=${this.placeholder}
          aria-label=${this.label ?? this.placeholder ?? lit_1.nothing}
          ?disabled=${this.disabled}
          aria-invalid=${(0, if_defined_js_1.ifDefined)(this.ariaInvalid ?? undefined)}
          aria-describedby=${this.describedBy || lit_1.nothing}
          @input=${this.handleInput}
        ></mm-input>
        <slot name="trailing"></slot>
      </div>
      ${(0, textfield_helpers_1.renderFieldDescription)(this.description, `${this.inputId}-description`)}
      ${(0, textfield_helpers_1.renderFieldValidation)(`${this.inputId}-validation`, this.validationText)}
    `;
    }
};
Textfield.styles = input_styles_1.textfieldStyles;
__decorate([
    (0, decorators_js_1.property)({ type: String })
], Textfield.prototype, "type", void 0);
Textfield = __decorate([
    (0, decorators_js_1.customElement)('mm-textfield')
], Textfield);
exports.Textfield = Textfield;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dGZpZWxkLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGV4dGZpZWxkLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUErQztBQUMvQyxxREFBMkQ7QUFDM0QsZ0VBQXdEO0FBSXhELHlFQUF3RTtBQUN4RSw2RkFLOEQ7QUFDOUQsMkNBQXdDO0FBR2pDLElBQU0sU0FBUyxHQUFmLE1BQU0sU0FBVSxTQUFRLElBQUEsc0NBQWtCLEVBQUMsZ0JBQVUsQ0FBQztJQUF0RDs7UUFFdUIsU0FBSSxHQUFjLE1BQU0sQ0FBQTtJQTBCdEQsQ0FBQztJQXhCQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTtRQUNQLElBQUEsb0NBQWdCLEVBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxJQUFJLENBQUMsS0FBSyxFQUFFLElBQUksQ0FBQyxRQUFRLENBQUM7O29EQUViLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsV0FBVyxJQUFJLFNBQVMsQ0FBQzs7O3FCQUd2RSxJQUFJLENBQUMsT0FBTztrQkFDZixJQUFJLENBQUMsSUFBSTttQkFDUixJQUFJLENBQUMsS0FBSztrQkFDWCxJQUFJLENBQUMsSUFBSTt5QkFDRixJQUFJLENBQUMsV0FBVzt1QkFDbEIsSUFBSSxDQUFDLEtBQUssSUFBSSxJQUFJLENBQUMsV0FBVyxJQUFJLGFBQU87c0JBQzFDLElBQUksQ0FBQyxRQUFRO3lCQUNWLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsV0FBVyxJQUFJLFNBQVMsQ0FBQzs2QkFDcEMsSUFBSSxDQUFDLFdBQVcsSUFBSSxhQUFPO21CQUNyQyxJQUFJLENBQUMsV0FBVzs7OztRQUkzQixJQUFBLDBDQUFzQixFQUFDLElBQUksQ0FBQyxXQUFXLEVBQUUsR0FBRyxJQUFJLENBQUMsT0FBTyxjQUFjLENBQUM7UUFDdkUsSUFBQSx5Q0FBcUIsRUFBQyxHQUFHLElBQUksQ0FBQyxPQUFPLGFBQWEsRUFBRSxJQUFJLENBQUMsY0FBYyxDQUFDO0tBQzNFLENBQUE7SUFDSCxDQUFDOztBQTFCTSxnQkFBTSxHQUFHLDhCQUFlLENBQUE7QUFDSDtJQUEzQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxJQUFJLEVBQUUsTUFBTSxFQUFFLENBQUM7dUNBQXlCO0FBRnpDLFNBQVM7SUFEckIsSUFBQSw2QkFBYSxFQUFDLGNBQWMsQ0FBQztHQUNqQixTQUFTLENBNEJyQjtBQTVCWSw4QkFBUyJ9